import { render, staticRenderFns } from "./PermissionItem.vue?vue&type=template&id=24d0964a&scoped=true&"
import script from "./PermissionItem.vue?vue&type=script&lang=js&"
export * from "./PermissionItem.vue?vue&type=script&lang=js&"
import style0 from "./PermissionItem.vue?vue&type=style&index=0&id=24d0964a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d0964a",
  null
  
)

export default component.exports